import React, { useState } from 'react'

import { connect } from 'react-redux'

import { useSpotify } from '../../../hoc/context/SpotifyContextContainer'
import { makeSpotifyPostRequest } from '../../../config/SpotifyRequests'

import Error from '../../../widgets/error/Error'
import Information from '../../../widgets/information/Information'

import PlayList from './Playlists'

function PlaylistsContainer({item, playlists, setModal}) {
    const { accessToken } = useSpotify()
    const addToPlaylist = (pid) => {
         makeSpotifyPostRequest(`https://api.spotify.com/v1/playlists/${pid}/tracks?uris=${item.uri}`, {}, accessToken)
        .then(res => setModal(<Information message={`Track added to play list.`} />))
        .catch(e =>setModal(<Error message={`An error has occured : make sure playlist is yours to modify!!!`} />))
        setModal(null)
    }
    return (
        <>
        {playlists.length > 0 &&  <PlayList add={addToPlaylist} setModal={setModal} playlists={playlists} />   }
        </>
    )
}



function mapStateToProps(state){
    return {
        playlists: state.playlists
    }
}

export default connect(mapStateToProps)(PlaylistsContainer)